// GraphQL queries and mutations for Purchase Orders
// TODO: Implement actual queries when backend API is available

export const getPurchaseOrderListQuery = `
  query GetPurchaseOrderList($input: GetPurchaseOrderListInput!) {
    getPurchaseOrderList(input: $input) {
      code
      message
      purchaseOrderList {
        id
        documentNumber
        supplierId
        supplierName
        status
        totalAmount
        currency
        expectedDeliveryDate
        createdAt
        updatedAt
      }
    }
  }
`;

export const getPurchaseOrderDetailQuery = `
  query GetPurchaseOrderDetail($input: GetPurchaseOrderDetailInput!) {
    getPurchaseOrderDetail(input: $input) {
      code
      message
      purchaseOrder {
        id
        documentNumber
        supplierId
        supplierName
        supplierAddress
        status
        isOpen
        totalReservedItems
        totalSoldItems
        reservationExpiresAt
        lineItems {
          id
          productId
          productName
          quantity
          unitPrice
          totalPrice
          unit
          itemEntries {
            id
            productItemId
            quantity
            status
            scannedAt
            reservedAt
            soldAt
            voidedAt
          }
        }
        subtotal
        tax
        shippingCost
        totalAmount
        currency
        expectedDeliveryDate
        deliveryAddress
        terms
        sourceDocumentId
        linkedDocuments {
          documentId
          documentType
          relationship
        }
        createdAt
        updatedAt
        notes
      }
    }
  }
`;

export const createPurchaseOrderMutation = `
  mutation CreatePurchaseOrder($input: CreatePurchaseOrderInput!) {
    createPurchaseOrder(input: $input) {
      code
      message
      purchaseOrder {
        id
        documentNumber
        status
        createdAt
      }
    }
  }
`;

export const convertToSalesOrderMutation = `
  mutation ConvertToSalesOrder($input: ConvertToSalesOrderInput!) {
    convertToSalesOrder(input: $input) {
      code
      message
      salesOrder {
        id
        documentNumber
        status
        createdAt
      }
    }
  }
`;

export const updatePurchaseOrderStatusMutation = `
  mutation UpdateOrderStatus($input: UpdateOrderStatusInput!) {
    updateOrderStatus(input: $input) {
      code
      order {
        orderId
        orderNumber
        companyId
        storeId
        status
        subtotalAmount
        taxAmount
        totalAmount
        customerId
        items {
          itemId
          quantity
          unitPrice
          lineTotal
          variationName
          detail {
            productItemId
            productName
            variationName
            unit
          }
        }
        createdAt
        updatedAt
        reservationExpiresAt
      }
    }
  }
`;
